import React, { useState, useEffect } from 'react';
import contractService from '../../services/ContractService';

const SlidePreviewPdf = ({ contract, show, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [fileUrl, setFileUrl] = useState(null);

    const closeSlide = () => {
        setIsLoading(false);
        setFileUrl(null);
        onClose();
    };
    const downloadPdf = () => {
        if (!fileUrl) return;
        const a = document.createElement('a');
        a.href = fileUrl;
        var typeName = contract.contractType.startsWith("Vendita") ? "VENDITA": "NOLEGGIO";
        var eventName = contract.eventName != '' ? contract.eventName+contract.eventYear : typeName;
        a.download = (contract.startDate.slice(0, 4) + contract.number.toString().padStart(3, "0")
            +'QTN_'+contract.clientName.replace(/\./g, '')+'_'+eventName+'.pdf').trim().replace(/\s+/g, '') ;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    const fetchPrevPdf= async (id) => {
        if (id) {
            setIsLoading(true);
            contractService.getPreview(id)
            .then((res) => {
                const url = URL.createObjectURL(res.data);
                setFileUrl(url);
            }).catch((error) => {
                console.error("Error get ,previewfile: ", error);
            });
        }
    }
    useEffect(() => {
        fetchPrevPdf(contract.id_contract);
    }, [contract]);

    return (
        <>
        <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title">Anteprima contratto {contract.number.toString().padStart(3, "0")}</h5>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
                <button onClick={downloadPdf} className="bx bx-download btn-download text-reset"></button>
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
                <div className="row">
                {isLoading && !fileUrl ? (
                    <p>Caricamento in corso...</p>
                ) : (
                        <iframe
                          src={fileUrl}
                          width="100%"
                          height="1000px"
                          title="Anteprima Contratto"
                        />
                )}
                </div>
            </div>
        </div>
        </>
  );
};

export default SlidePreviewPdf;
